import { OnboardingState } from '@ekhodealer/ekho-common';

import type { AdminGetMeResponse} from '@ekhodealer/ekho-common';

import { paths } from '@config/paths';

export type AuthFlowTarget =
	| { kind: 'portal'; path: string }
	| { kind: 'setup'; path: string }
	| { kind: 'mfa'; path: string };

/**
 * Maps server-provided onboarding state to the correct flow route.
 *
 * NOTE: keep this mapping dumb and server-driven; no claim decoding and no
 * client-side scope computation.
 */
export function getAuthFlowTarget(
	onboardingState: OnboardingState | null | undefined,
): AuthFlowTarget {
	switch (onboardingState) {
		case OnboardingState.INVITED:
		case OnboardingState.MIGRATING:
		case OnboardingState.NEEDS_PROFILE:
			return { kind: 'setup', path: paths.setupProfile.getHref() };
		case OnboardingState.NEEDS_EMAIL_VERIFICATION:
			return { kind: 'setup', path: paths.setupVerifyEmail.getHref() };
		case OnboardingState.NEEDS_MFA:
			return { kind: 'setup', path: paths.setupMfa.getHref() };
		case OnboardingState.COMPLETE:
			return { kind: 'portal', path: paths.home.getHref() };
		default:
			// Safest fallback is setup
			return { kind: 'setup', path: paths.setupProfile.getHref() };
	}
}

/**
 * Determines the post-login redirect path based on admin /me response.
 */
export function getPostLoginRedirect(me: AdminGetMeResponse): string {
	// Access check takes precedence (except for setup flows)
	if (me.canAccessAdminPortal === false) {
		return paths.noAccess.getHref();
	}

	// Route based on onboarding state
	return getAuthFlowTarget(me.onboardingState).path;
}
